import { docReady } from '../helpers/docReady';
import '../../styles/templates/product.scss';
import { productGallery } from '../snippets/productGallery';
import { addToCartMessage } from '../snippets/productInfoAddToCartMessage';
import { buyNowPayLater } from '../snippets/productInfoBuyNowPayLater';
import { countdownTimer } from '../snippets/productInfoCountdownTimer';
docReady(() => {
    // console.log('Product Template');
    productGallery();
    addToCartMessage();
    buyNowPayLater();
    countdownTimer();
});
